/* Shared bits used by all Phase-1 pages. */
import { AlertTriangle } from "lucide-react";

export function PageHeader({ icon: Icon, title, subtitle, actions, testid }) {
  return (
    <header className="px-4 sm:px-6 pt-6 pb-4 border-b border-zinc-800" data-testid={testid}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <div className="h-9 w-9 rounded-md bg-emerald-500/10 border border-emerald-700/30 flex items-center justify-center shrink-0">
              <Icon className="h-4 w-4 text-emerald-400" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="text-xl font-semibold tracking-tight truncate">{title}</h1>
            {subtitle && <div className="text-xs text-zinc-500 mt-0.5">{subtitle}</div>}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}

export function Banner({ children, tone = "info", testid }) {
  const map = {
    info: "border-emerald-800/60 bg-emerald-950/20 text-emerald-200",
    warn: "border-amber-900/60 bg-amber-950/20 text-amber-200",
  };
  return (
    <div className={`mx-4 sm:mx-6 mt-4 rounded-md border px-3 py-2 text-xs ${map[tone]}`} data-testid={testid}>
      {children}
    </div>
  );
}

export function ErrorBlock({ data, testid }) {
  if (!data) return null;
  return (
    <div className="p-3 rounded-md border border-amber-900/60 bg-amber-950/30" data-testid={testid}>
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
        <div className="text-xs min-w-0">
          <div className="text-amber-200 font-medium mb-1 break-words">{data.error || "Error"}</div>
          {data.detail && <div className="text-zinc-400 mb-2 leading-relaxed break-words">{typeof data.detail === "string" ? data.detail : JSON.stringify(data.detail)}</div>}
          {data.recommendation && <div className="text-emerald-300/90 mono text-[11px]">→ {data.recommendation}</div>}
          {data.action && <div className="text-emerald-300/90 mono text-[11px]">→ {data.action}</div>}
        </div>
      </div>
    </div>
  );
}

export function PageBody({ children }) {
  return <div className="px-4 sm:px-6 py-6 space-y-6">{children}</div>;
}

export function fmtCurrency(price, currency) {
  if (price == null) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(price);
  } catch {
    return `${currency || ""} ${price}`;
  }
}
